<template>
  <v-form ref="form" @submit.prevent="submit" v-model="formValid">
    <QuotationDeadlineStartTerm
      :form="value"
      @return="previousStep"
      :readonlyForm="readonlyForm"
      :options-quotation="optionsQuotation"
    />
    <QuotationDeadlineEmissionType
      :form="value"
      :options-quotation="optionsQuotation"
      :readonlyForm="readonlyForm"
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-0 pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotation"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'PRÓXIMO'"
            class="white--text secondary"
            width="100%"
            :disabled="loading"
            @click="submit()"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import QuotationDeadlineStartTerm from "./QuotationDeadlineStartTerm";
import QuotationDeadlineEmissionType from "./QuotationDeadlineEmissionType";
import { mapActions } from "vuex";
export default {
  data: () => ({
    formValid: true,
    loading: false
  }),
  components: {
    QuotationDeadlineEmissionType,
    QuotationDeadlineStartTerm
  },
  computed: {
    checkValidForm() {
      return (
        (this.isTypeProcessRequired && Boolean(this.value.tipo_processo.id)) ||
        !this.isTypeProcessRequired
      );
    },
    isTypeProcessRequired() {
      return this.optionsQuotation.processo_judiciario.tipo_processo
        .obrigatorio;
    }
  },
  methods: {
    ...mapActions(["showAlertNotification"]),
    submit() {
      if (!this.checkValidForm) {
        this.showAlertNotification({
          message:
            "É necessário escolher um tipo de processo e preencher o formulário.",
          type: "error"
        });
        return;
      }
      if (!this.$refs.form.validate()) return;
      this.$emit("submit", this.value);
    },
    cancelQuotation() {
      this.$emit("cancel");
    },
    previousStep() {
      this.$emit("return");
    }
  },
  props: {
    value: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    }
  }
};
</script>
